import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'
import { storeAffiliateIds } from './lib/affiliates.ts'

if (typeof window !== 'undefined') {
  import('./pwa')

  // https://vite.dev/guide/build#load-error-handling
  window.addEventListener('vite:preloadError', (_event) => {
    window.location.reload()
  })
}

storeAffiliateIds();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
